
import { AvatarDisplay } from "./components/AvatarDisplay";
import { UploadControls } from "./components/UploadControls";
import { useAvatarUpload } from "./hooks/useAvatarUpload";
import { useIsMobile } from "./hooks/useIsMobile";

interface ProfileAvatarProps {
  userId: string;
  avatarUrl: string | null;
  firstName: string;
  lastName: string;
  onAvatarChange: (url: string) => void;
}

export const ProfileAvatar = ({ 
  userId, 
  avatarUrl, 
  firstName, 
  lastName, 
  onAvatarChange 
}: ProfileAvatarProps) => {
  const isMobile = useIsMobile();
  const { isUploading, handleImageUpload, handleRemoveAvatar } = useAvatarUpload({
    userId,
    avatarUrl,
    onAvatarChange
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      handleImageUpload(file);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <AvatarDisplay 
        avatarUrl={avatarUrl}
        firstName={firstName}
        lastName={lastName}
        isUploading={isUploading}
        onRemoveAvatar={handleRemoveAvatar}
      />
      
      <UploadControls 
        isUploading={isUploading}
        isMobile={isMobile}
        onFileChange={handleFileChange}
      />
    </div>
  );
};
